/**
 * Markdown-lite → React nodes (AN TOÀN, không dùng dangerouslySetInnerHTML).
 *
 * Chỉ hỗ trợ tập con đủ dùng cho câu trả lời của trợ lý AI: heading (#/##/###),
 * gạch đầu dòng (-/*), danh sách số (1.), in đậm (**...**), mã (`...`). Không tải
 * thư viện markdown ngoài (dự án chưa có). Nếu cần đầy đủ markdown sau này, cân
 * nhắc thêm `marked` + `dompurify` (đã có sẵn dompurify).
 */

/** Xử lý inline: **đậm** và `mã`. Trả mảng React node. */
function inline(text, keyPrefix) {
	const nodes = [];
	const regex = /(\*\*[^*]+\*\*|`[^`]+`)/g;
	let last = 0;
	let m;
	let i = 0;

	while ((m = regex.exec(text)) !== null) {
		if (m.index > last) nodes.push(text.slice(last, m.index));
		const tok = m[0];
		if (tok.startsWith('**')) nodes.push(<strong key={`${keyPrefix}-b${i}`}>{tok.slice(2, -2)}</strong>);
		else nodes.push(<code key={`${keyPrefix}-c${i}`}>{tok.slice(1, -1)}</code>);
		last = m.index + tok.length;
		i++;
	}
	if (last < text.length) nodes.push(text.slice(last));
	return nodes;
}

function Markdown({content, className}) {
	const lines = String(content || '').split('\n');
	const blocks = [];
	let list = null; // {type:'ul'|'ol', items:[]}

	const flush = () => {
		if (list) {
			blocks.push(list);
			list = null;
		}
	};

	lines.forEach((raw) => {
		const line = raw.replace(/\s+$/, '');
		const ul = line.match(/^\s*[-*]\s+(.*)$/);
		const ol = line.match(/^\s*\d+[.)]\s+(.*)$/);
		const h = line.match(/^(#{1,3})\s+(.*)$/);

		if (ul) {
			if (!list || list.type !== 'ul') {
				flush();
				list = {type: 'ul', items: []};
			}
			list.items.push(ul[1]);
		} else if (ol) {
			if (!list || list.type !== 'ol') {
				flush();
				list = {type: 'ol', items: []};
			}
			list.items.push(ol[1]);
		} else if (h) {
			flush();
			blocks.push({type: 'h', level: h[1].length, text: h[2]});
		} else if (line.trim() === '') {
			flush();
		} else {
			flush();
			blocks.push({type: 'p', text: line});
		}
	});
	flush();

	return (
		<div className={className}>
			{blocks.map((b, i) => {
				if (b.type === 'ul') return <ul key={i}>{b.items.map((it, j) => <li key={j}>{inline(it, `${i}-${j}`)}</li>)}</ul>;
				if (b.type === 'ol') return <ol key={i}>{b.items.map((it, j) => <li key={j}>{inline(it, `${i}-${j}`)}</li>)}</ol>;
				if (b.type === 'h') {
					const Tag = `h${Math.min(b.level + 2, 6)}`;
					return <Tag key={i}>{inline(b.text, i)}</Tag>;
				}
				return <p key={i}>{inline(b.text, i)}</p>;
			})}
		</div>
	);
}

export default Markdown;
